import { Navigate } from 'react-router-dom';
import StoryForm from '../features/story/StoryForm';
import StoryRepository from '../features/story/StoryRepository';
import StoryView from '../features/story/StoryView';
import { isSuperAdmin } from '../library/Core/SmartFunctions';
import { default as AlumniProfileEditLayout } from '../app/alumni/AlumniProfileEditLayout';
import BlankLayout from '../app/alumni/BlankLayout';
import StandardLayout from '../app/alumni/StandardLayout';
import ManagementLayout from '../app/management/ManagementLayout';
import Dashboardadmin from '../features/admin/dashboard/Dashboard';
import AdminLogin from '../features/admin/login/AdminLogin';
import EmailVerification from '../features/alumni/EmailVerification/EmailVerification';
import Dashboard from '../features/alumni/dashboard/Dashboard';
import DashboardService from '../features/alumni/dashboard/DashboardPageLoader';
import AlumniProfileImage from '../features/alumni/profile-edit/basic-info/AlumniProfileImage';
import StudentPreference from '../features/alumni/profile-edit/student-preference/StudentPreference';
import AlumniEmailVerification from '../features/alumni_email_verification/AlumniEmailVerification';
import PeerInvite from '../features/alumni_invite/invite';
import PeerReviewService from '../features/alumni_review/PeerReviewService';
import AdminPeerReview from '../features/alumni_review/admin_peer_review';
import PeerReview from '../features/alumni_review/peer_review';
import InstituteSelection from '../features/auth/institute-selection/InstituteSelection';
import Login from '../features/auth/login/Login';
import RedirectToUserLogin from '../features/auth/login/RedirectToUserLogin';
import AutoLogin from '../features/autologin/AutoLogin';
import AdminAdditionalInfo from '../features/management/admin-profile/edit/additional-info/AdminAdditionalInfo';
import AdminBasicInfo from '../features/management/admin-profile/edit/basic-info/AdminBasicInfo';
import AdminPreferences from '../features/management/admin-profile/edit/preferences/AdminPreferences';
import AdminProfile from '../features/management/admin-profile/view/AdminProfile';
import ManageAlumni from '../features/management/alumni-list/ManageAlumni';
import ManageAlumniService from '../features/management/alumni-list/ManageAlumniService';
import ManagementDashboard from '../features/management/dashboard/new/ManagementDashboard';
import ManagementDashboardService from '../features/management/dashboard/new/ManagementDashboardService';
import OutreachDashboard from '../features/management/outreach-dashboard/OutreachDashboard';
import OutreachDashboardService from '../features/management/outreach-dashboard/OutreachDashboardService';
import Home from '../features/management/home/Home';
import ManagementLogin from '../features/management/login/ManagementLogin';
import AlumniNotification from '../features/notification/AlumniNotification';
import Commerece from '../features/psychometric_test/careerGuide/Commerece';
import Engineering from '../features/psychometric_test/careerGuide/Engineering';
import Humanities from '../features/psychometric_test/careerGuide/Humanities';
import Idealcareertest from '../features/psychometric_test/careerGuide/Idealcareertest';
import Learningstyletest from '../features/psychometric_test/careerGuide/Learningstyletest';
import MultipleIntelligenceTest from '../features/psychometric_test/careerGuide/MultipleIntelligenceTest';
import PersonalityTest from '../features/psychometric_test/careerGuide/PersonalityTest';
import StreamSelectorTest from '../features/psychometric_test/careerGuide/SreamSelectorTest';
import StudentManagementReport from '../features/reports/student-management/StudentManagementReport';
import ShareMyProfile from '../features/share-profile/sharemyprofile';


//Added by Vikash
import Sendemail from '../features/broadcast/create-broadcast/sendemail';
import AddContent from '../features/broadcast/create-broadcast/AddContent';
import TemplatePreview from '../features/broadcast/email-preview/TemplatePreview';
import TemplatePreviewLater from '../features/broadcast/email-preview/TemplatePreviewLater';
import DraftMail from '../features/broadcast/draft/DraftMail';
import EmailPreview from '../features/broadcast/email-preview/preview';
import ManageStudent from '../features/broadcast/student/ManageAlumni';
import ScheduleMail from '../features/broadcast/draft/Schedulemail';
import SentMail from '../features/broadcast/draft/sentmail';
import PreviewLater from '../features/broadcast/email-preview/previewlater';
import ManageBroadcastLead from '../features/broadcast/lead-list/ManageLead';
import TemplateList from '../features/broadcast/email-template/TemplateList';
import GoogleReview from '../features/broadcast/draft/GoogleReview.tsx';
import AddGoogleReview from '../features/broadcast/email-preview/AddGoogleReview.tsx';
import AddReferral from '../features/broadcast/draft/AddReferral.tsx';
import HtmlTemplate from '../features/broadcast/html/HtmlTemplate';
import UploadMoengage from '../features/broadcast/moengage/UploadReport';
import UpdateAlumniService from '../features/admin/updateAlumni/UpdateAlumniService';
import UpdateAlumni from '../features/admin/updateAlumni/UpdateAlumni';

import AddImage from '../features/image_template/add/AddSpotlights';
import FutureLeaders from '../features/image_template/add/FutureLeaders';
import FutureLeadersThree from '../features/image_template/add/FutureLeadersThree';
import FutureLeadersFour from '../features/image_template/add/FutureLeadersFour';
import WebinarCertificate from '../features/image_template/add/WebinarCertificate';
import ImageTemplate from '../features/image_template/ImageTemplate';
import MembershipCard from '../features/image_template/add/MembershipCard';
import RisingStar from '../features/image_template/add/RisingStar';
import SuccessStory from '../features/image_template/add/SuccessStory';
import AddSpotlightsInsta from '../features/image_template/add/AddSpotlightsInsta';
import FutureLeadersInst from '../features/image_template/add/FutureLeadersInsta';
import FutureLeadersThreeInsta from '../features/image_template/add/FutureLeadersThreeInsta';
import FutureLeadersFourInsta from '../features/image_template/add/FutureLeadersFourInsta';
import FiveTemplate from '../features/image_template/add/FiveTemplate';
import FutureLeadersSix from '../features/image_template/add/FutureLeadersSix'
import FutureLeadersSeven from '../features/image_template/add/FutureLeadersSeven'
import FutureLeadersEight from '../features/image_template/add/FutureLeadersEight'
import FutureLeadersNine from '../features/image_template/add/FutureLeadersNine'
import Company from '../features/admin/manage-company/Company';
import CompanyListing from '../features/admin/manage-company/CompanyListing';
import CompanyListingService from '../features/admin/manage-company/CompanyListingService';
import CompanyService from '../features/admin/manage-company/CompanyService';
import CompanyView from '../features/admin/manage-company/CompanyView';
import AlumniActivityDashboard from '../features/admin/alumni-activity-dashboard/AlumniActivityDashboard';
import VibrancyDashboard from '../features/admin/vibrancy-dashboard/VibrancyDashboard';

import InstituteAdminReports from '../features/admin/institute-automation/InstituteAdminReports';
import PreviewSendPage from '../features/admin/institute-automation/components/PreviewSendPage';
import InstituteReportView from '../features/admin/institute-automation/components/InstituteReportView';
//Added by Vikash

import Screening from '../features/pre_signup/Screening';
import ScreeningInfo from '../features/pre_signup/ScreeningInfo';
import IdenetyUser from '../features/pre_signup/IdentifyUser';
import Parent from '../features/pre_signup/Parent';
import ParentChildInfo from '../features/pre_signup/ParentChildInfo';
import ThanksPage from '../features/pre_signup/ThanksPage';
import PastStudent from '../features/pre_signup/PastStudent';
import Reference from '../features/pre_signup/Reference';
import ReferenceOtp from '../features/pre_signup/ReferenceOtp';
import VerifyProgress from '../features/pre_signup/VerifyProgress';
import UserTrack from '../features/pre_signup/UserTrack';
import ManageReferral from '../features/pre_signup/report/ManageReferral';
import ManageReferralService from '../features/pre_signup/report/ManageReferralService';
import UpdateTrack from '../features/pre_signup/referral/UpdateTrack';
import ViewTrack from '../features/pre_signup/referral/ViewTrack';
import AlumniEntry from '../features/pre_signup/AlumniEntry';
//Above Added for pre Signup by Vikash
import RyanLogin from '../features/grouplogin/Ryan';
import EuroLogin from '../features/grouplogin/Euro';
import BhisLogin from '../features/grouplogin/Bhis';
import BomisLogin from '../features/grouplogin/Bomis';
import AsterLogin from '../features/grouplogin/Aster';
import VishwakarmaLogin from '../features/grouplogin/Vishwakarma';
import PodarLogin from '../features/grouplogin/Podar';
import VgosLogin from '../features/grouplogin/vgos';
import Adityaacademy from '../features/grouplogin/Adityaacademy';
import Adityabirla from '../features/grouplogin/Abps';
//Above Added for Group login by Vikash
import BrowseFile from '../features/lead/import-lead/browsefile';
//import AddLead from '../features/lead/add-lead/addnewlead';
import ManageLead from '../features/lead/view/ManageLead';
import ManageLeadService from '../features/lead/view/ManageLeadService';
import AddLeadInfo from '../features/lead/add-lead/addnewleadinfo';
import AddLeadProgram from '../features/lead/add-lead/addnewleadprogram';
import EditLeadInfo from '../features/lead/update-lead/leadinfo';
import TargetProgram from '../features/lead/update-lead/targetprogram';
import ViewProfile from '../features/lead/update-lead/viewprofile';
import UpdateProgram from '../features/lead/update-lead/UpdateProgram';
import StudentAchievement from '../features/student/edit/achievement/StudentAchievement';
import StudentActivity from '../features/student/edit/activity/StudentActivity';
import StudentBasicInfo from '../features/student/edit/basic-info/StudentBasicInfo';
import StudentBooks from '../features/student/edit/books/StudentBooks';
import Education from '../features/student/edit/education/Education';
import EntranceExam from '../features/student/edit/entrance-exams/EntranceExam';
import Parents from '../features/student/edit/parents/Parents';
import StudentSignup from '../features/student/signup/StudentSignup';
import StudentProfile from '../features/student/view/StudentProfile';
import EducationDetails from '../features/student/view/sections/EducationDetails';
import EntranceExams from '../features/student/view/sections/EntranceExams';
import ExtraCurricular from '../features/student/view/sections/ExtraCurricular';
import ParentInformation from '../features/student/view/sections/ParentInformation';
import Preferences from '../features/student/view/sections/Preferences';
import pageLoader from '../library/Core/PageLoader';
import ErrorPage from '../library/SimpleControls/ErrorPage';
import StudentService from '../services/student.service';
//import AutoLogin from '../features/autologin/AutoLogin';
//Added By Seerish
import AlumniMatchStudents from '../features/admin/alumni_match_students/AlumniMatchStudents';
import AlumniMatchStudentsService from '../features/admin/alumni_match_students/AlumniMatchStudentsService';
import BurnerAnalysisInstitutes from '../features/admin/burner_analysis/BurnerAnalysisInstitutes';
import BurnerAnalysisAlumni from '../features/admin/burner_analysis/BurnerAnalysisAlumni';
import BurnerAnalysisService from '../features/admin/burner_analysis/BurnerAnalysisService';
import AlumniSchoolSupport from '../features/admin/alumni_school/AlumniSchoolSupport';
import AlumniSchoolSupportService from '../features/admin/alumni_school/AlumniSchoolSupportService';
import CreateNewAlumni from '../features/admin/create_new_alumni/CreateNewAlumni';
import CreateNewAlumniService from '../features/admin/create_new_alumni/CreateNewAlumniService';
import Schooltestmapping from '../features/admin/dashboard/Schooltestmapping';
import ManageAlumniEngage from '../features/management/alumni-list/ManageAlumniEngage';
import ManageAlumniServiceEngage from '../features/management/alumni-list/ManageAlumniServiceEngage';

//Event links
//Added By Seerish
import AddNew from '../features/eventmanage/add/AddNew';
import AddNewService from '../features/eventmanage/add/AddnewService';
//import BasicDetails from '../features/eventmanage/add/BasicDetails'
import SpeakerInfo from '../features/eventmanage/add/SpeakerInfo';
import SpeakerInfoService from '../features/eventmanage/add/SpeakerInfoService';
import AudienceCategory from '../features/eventmanage/add/AudienceCategory';
import AudienceCategoryService from '../features/eventmanage/add/AudienceCategoryService';
import ThemeOptions from '../features/eventmanage/add/ThemeOptions';
import ThemeOptionsService from '../features/eventmanage/add/ThemeOptionsService';
import AddAttendance from '../features/eventmanage/add/AddAttendance';
import AddAttendanceService from '../features/eventmanage/add/AddAttendanceService';
import ManageEvent from '../features/eventmanage/view/ManageEvent';
import ManageEventService from '../features/eventmanage/view/ManageEventService';

import ManagePsyLink from '../features/psychometriclinks/view/ManagePsyLink';
import ManagePsyLinkService from '../features/psychometriclinks/view/ManagePsyLinkService';
import AddPsyNew from '../features/psychometriclinks/add/AddNew';
import AddPsyNewService from '../features/psychometriclinks/add/AddnewService';

import KeytwosuccessTest from '../features/psychometric_test/careerGuide/KeytwosuccessTest';

//ADDED By Seerish - Social post links

import ManageSocialIntegrations from '../features/socialsharing/ManageSocialIntegrations';
import SocialMedia from '../features/socialsharing/SocialMedia';
import SocialPost from '../features/socialsharing/SocialPost';

//added by vrinda
import EngagementLayout from '../app/admin/EngagementLayout';
import AlumniConversions from '../features/admin/engagement-list/AlumniConversions';
import AlumniConversionsService from '../features/admin/engagement-list/AlumniConversionsService';
import AlumniEngagement from '../features/admin/engagement-list/AlumniEngagement';
import AlumniEngagementService from '../features/admin/engagement-list/AlumniEngagementService';
import AlumniSelectedConversions from '../features/admin/engagement-list/AlumniSelectedConversions';
import InternalAdminReport from '../features/admin/reports/InternalAdminReport';
import InternalAdminReportService from '../features/admin/reports/InternalAdminReportService';
import WatchlistDashboard from '../features/admin/watchlist-dashboard/WatchlistDashboard';
import PlacementAnalyticsListing from '../features/admin/placement-analytics/PlacementAnalyticsListing';
import PlacementInstituteShell from '../features/admin/placement-analytics/PlacementInstituteShell';
import WatchlistReportPage from '../features/watchlists/report/WatchlistReportPage';
import CustomWatchlistReportPage from '../features/watchlists/custom-report/CustomWatchlistReportPage';
import HitlReviewQueuePage from '../features/watchlists/hitl/HitlReviewQueuePage';
import HitlConfigPage from '../features/watchlists/hitl/HitlConfigPage';
// Added by Irfan shaikh
import Contact from '../features/admin/contact/Contact';
import ContactService from '../features/admin/contact/ContactService';
import DomainCategoryDataService from '../features/admin/domain-data/DomainCategoryDataService';
import DomainDetail from '../features/admin/domain-data/DomainDetail';
import Institute from '../features/admin/institute/Institute';
import InstituteLisingService from '../features/admin/institute/InstituteLisingService';
import InstituteListing from '../features/admin/institute/InstituteListing';
import InstituteService from '../features/admin/institute/InstituteService';
import CreateinstituteProgram from '../features/institute-program/CreateinstituteProgram';
import InstituteProgramService from '../features/institute-program/InstituteProgramService';
import ProgramLisingService from '../features/institute-program/ProgramLisingService';
import ProgramListing from '../features/institute-program/ProgramListing';
import SchoolApi from '../features/mainadmin/SchoolApi';
import SchoolApiService from '../features/mainadmin/SchoolApiService';
import { alumniRoutes } from './alumni-routes';
import ContactLisingService from '../features/admin/contact/ContactLisingService';
import ContactListing from '../features/admin/contact/ContactListing';

// Seerish  on 20-05-2024

import AddGuidingAlumni from '../features/widgets/alumni_guiding/AddGuidingAlumni';
import GuidingAlumniPreview from '../features/widgets/alumni_guiding/GuidingAlumniPreview';
import GuidingAlumniPreviewFrontend from '../features/widgets/alumni_guiding/GuidingAlumniPreviewFrontend';
import ManageWidgetsList from '../features/widgets/ManageWidgetsList';
import ManageWidgetsListService from '../features/widgets/ManageWidgetsListService';
import WidgetService from '../features/widgets/WidgetService';
import WidgetConfiguration from '../features/widgets/WidgetConfiguration';
import AddGuidingAlumniList from '../features/widgets/alumni_guiding/AddGuidingAlumniList';
import WidgetServiceList from '../features/widgets/WidgetServiceList';
import WidgetConfigurationList from '../features/widgets/WidgetConfigurationList';

import BasAdminReport from '../features/admin/basreports/BasAdminReport';
import BasAdminReportService from '../features/admin/basreports/BasAdminReportService';
import BusinessDirectory from '../features/admin/business-directory/BusinessDirectory';
import BusinessDirectoryService from '../features/admin/business-directory/BusinessDirectoryService';
import AiSuggestedDirectory from '../features/admin/business-directory/AiSuggestedDirectory';
import AiSuggestedService from '../features/admin/business-directory/AiSuggestedService';

// Added By Irfan Shaikh
// Date : 20-05-2024
// Purpose : Colleges Tools
import TopColleges from '../features/top-colleges/TopColleges';
import CollegeService from '../features/top-colleges/CollegeService';
import RedirectToUserSignup from '../features/auth/login/RedirectToUserSignup';
import ManageWidgetsAlumni from '../features/widgets/ManageWidgetsAlumni';
import HandleLinkedInCallback from '../features/admin/login/HandleLinkedInCallback';
import HandleGoogleCallback from '../features/admin/login/HandleGoogleCallback';
import SignupSocial from '../features/admin/login/SignupSocial';

import Configuration from '../features/widgets/Configuration';
import ProfileMarkerNotesService from '../features/admin/Profile-marker-notes/ProfileMarkerNotesService';
import ProfileMarkerNotes from '../features/admin/Profile-marker-notes/ProfileMarkerNotes';

import StudentDashboard from '../features/qna/StudentDashboard';
import QnaApiService from '../features/qna/QnaApiService';
import ConversionsReport from '../features/admin/conversation_report/ConversionsReport';
import ConversationReportService from '../features/admin/conversation_report/ConversationReportService';
import PsychometricTestMapping from '../features/psychometric_test/mapping/PsychometricTestMapping';
import PsychometricTestMappingService from '../features/psychometric_test/mapping/PsychometricTestMappingService';
import PreviewService from '../features/eventmanage/add/PreviewService';
import Preview from '../features/eventmanage/add/Preview';
import UploadUserService from '../features/admin/uploadUser/UploadUserService';
import UploadUser from '../features/admin/uploadUser/UploadUser';
import UploadOutreachService from '../features/admin/uploadOutreach/UploadOutreachService';
import UploadOutreach from '../features/admin/uploadOutreach/UploadOutreach';
import SocialLoginSuccess from '../features/socialsharing/SocialLoginSuccess';
import SocialPostList from '../features/socialsharing/SocialPostList';
import SocialPostListService from '../features/socialsharing/SocialPostListService';

import ManageProfileMarkerList from '../features/management/profile-marker/ManageProfileMarkerList';
import ManageProfileMarkerSyncService from '../features/management/profile-marker/ManageProfileMarkerSyncService';
import InstagramLoginSuccess from '../features/socialsharing/InstagramLoginSuccess';
import LinkedinLoginSuccess from '../features/socialsharing/LinkedinLoginSuccess';
import ProfileLevelDetail from '../features/admin/profile-levels/ProfileLevelDetail';
import ProfieLevelSyncService from '../features/admin/profile-levels/ProfieLevelSyncService';
import RenderFeedbackForm from '../features/feedback/RenderFeedbackForm';
import PaceFormParentSelfBooking from '../features/student/view/sections/PaceFormParentSelfBooking';
import UploadParentService from '../features/admin/uploadParent/UploadParentService';
import UploadParent from '../features/admin/uploadParent/UploadParent';
import InternalAdminStudentReport from '../features/admin/reports/InternalAdminStudentReport';
import ActivityLogReport from '../features/management/alumni-list/ActivityLogReport';
import TopCareer from '../features/top-career/TopCareer';
import CareerDetails from '../features/top-career/CareerDetails';
import RecruiterDashboard from '../features/management/dashboard/recruiter/RecruiterDashboard';
import RecruiterDashboardService from '../features/management/dashboard/recruiter/RecruiterDashboardService';
import ProfileAnalyticsDashboardPage from '../features/management/profile-analytics-dashboard/ProfileAnalyticsDashboardPage';
import ResetTwoFaAction from '../features/management/login/ResetTwoFaAction';
import UploadProfileMarker from '../features/admin/uploadProfileMarker/UploadProfileMarker';
import UploadProfileMarkerService from '../features/admin/uploadProfileMarker/UploadProfileMarkerService';
import UploadRecruiter from '../features/admin/uploadRecruiter/UploadRecruiter';
import UploadRecruiterService from '../features/admin/uploadRecruiter/UploadRecruiterService';
import SchoolStatisticsService from '../features/admin/school-statistics/SchoolStatisticsService';
import UploadTrackerService from '../features/admin/uploadTracker/UploadTrackerService';
import UploadTrackerData from '../features/admin/uploadTracker/UploadTrackerData';
import SchoolAdminStatisticsReport from '../features/admin/school-statistics/SchoolAdminStatisticsReport';
import InternalAdminQRReportService from '../features/admin/reports/qrReports/InternalAdminQRReportService';
import InternalAdminQRReport from '../features/admin/reports/qrReports/InternalAdminQRReport';
import HandleKeycloakCallback from '../features/admin/login/HandleKeycloakCallback';
import Grievance from '../features/admin/grievance/Grievance';
import GrievanceService from '../features/admin/grievance/GrievanceService';
import InstituteAdminGrievanceScreen from '../features/admin/grievance-management/institute-admin/InstituteAdminGrievanceScreen';
import InstituteAdminGrievanceService from '../features/admin/grievance-management/services/InstituteAdminGrievanceService';
import InternalAdminGrievanceReport from '../features/admin/grievance-management/internal-admin/InternalAdminGrievanceReport';
import InternalAdminGrievanceService from '../features/admin/grievance-management/services/InternalAdminGrievanceService';
import KeyCloakStudentSelection from '../features/auth/keycloak-vibgyor-student-selection/KeyCloakStudentSelection';
import HandleVibgyorLogin from '../features/admin/login/HandleVibgyorLogin';
import CommitmentCapture from '../features/admin/commitment/CommitmentCapture';
import CommitmentTracker from '../features/admin/commitment/CommitmentTracker';
import CommitmentService from '../features/admin/commitment/CommitmentService';

//const schoolDomainFromLocalStorage = JSON.parse(localStorage.getItem('school_settings'))?.schoolDomain ?? '';
//const schoolSettings = localStorage.getItem('school_settings');
// const schoolDomainFromLocalStorage = schoolSettings ? JSON.parse(schoolSettings)?.schoolDomain ?? '' : '';
const routes = [
    alumniRoutes,
    // {
    //     path: '/',
    //     errorElement: <ErrorPage />,
    //     element: <Navigate to={`/alumni/${schoolDomainFromLocalStorage}/login`} replace />,
    // },
    {
        path: '/handle-linkedin-login',
        errorElement: <ErrorPage />,
        element: <HandleLinkedInCallback pageTitle="LinkedIn Login" />,
    },
    {
        path: '/handle-google-login',
        errorElement: <ErrorPage />,
        element: <HandleGoogleCallback pageTitle="Google Login" />,
    },
    {
        path: '/handle-keycloak-login',
        errorElement: <ErrorPage />,
        element: <HandleKeycloakCallback pageTitle="Keycloak Login" />,
    },
    {
        path: '/handle-vibgyor-login',
        errorElement: <ErrorPage />,
        element: <HandleVibgyorLogin pageTitle="Keycloak Login" />,
    },
    {
        path: '/keycloak-student-selection',
        errorElement: <ErrorPage />,
        element: <KeyCloakStudentSelection pageTitle="Keycloak Student Selection" />,
    },
    {
        path: '/social-signup',
        errorElement: <ErrorPage />,
        loader: async ({ params }) => {
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <SignupSocial pageTitle="Signup" />,
    },
    {
        path: '/select-institute',
        errorElement: <ErrorPage />,
        element: <InstituteSelection pageTitle="Choose the Network" />,
    },
    {
        path: '/reset-2fa/:token',
        errorElement: <ErrorPage />,
        element: <ResetTwoFaAction pageTitle="Reset Two-Factor Authentication" />,
    },
    {
        path: 'user/:schoolDomain?/login/:invitedBy?',
        loader: async ({ params }) => {
            document.title = 'Welcome to Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
        element: <Login />,
    },
    {
        path: 'user/:schoolDomain?/signup/:invitedBy?',
        loader: async ({ params }) => {
            document.title = 'Join Your Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <Login />,
    },
    {
        path: '/alumni/:schoolDomain?/login/:invitedBy?',
        loader: async ({ params }) => {
            document.title = 'Welcome to Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
        element: <RedirectToUserLogin />,
    },
    {
        path: '/student/:schoolDomain?/login/:invitedBy?',
        loader: async ({ params }) => {
            document.title = 'Welcome to Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
        element: <RedirectToUserLogin />,
    },

    {
        path: 'alumni/:schoolDomain?/signup/:invitedBy?',
        loader: async ({ params }) => {
            document.title = 'Join Your Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <RedirectToUserSignup />,
    },
    {
        path: 'student/:schoolDomain?/signup/:invitedBy?',
        loader: async ({ params }) => {
            document.title = 'Join Your Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <RedirectToUserSignup />,
    },
    // {
    //     path: '/student/:schoolDomain',
    //     children: [
    //         {
    //             path: 'signup',
    //             loader: async ({ params }) => {
    //                 return pageLoader({ ...params, pageName: 'student-signup' });
    //             },
    //             element: <StudentSignup />,
    //         },
    //         {
    //             path: 'login',
    //             loader: async ({ params }) => {
    //                 return pageLoader({ ...params, pageName: 'student-login' });
    //             },
    //             element: <StudentSignup />,
    //         },
    //     ],
    //     errorElement: <ErrorPage />,
    // },
    {
        path: '/internal-dashboard',
        children: [
            {
                path: 'login',
                element: <AdminLogin pageTitle="Univariety" />,
            },
            {
                path: 'dashboard',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <Dashboardadmin />,
            },
            {
                path: 'Schooltestmapping',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <Schooltestmapping />,
            },
        ],
        errorElement: <ErrorPage />,
    },
    {
        path: '/psychometric_test',
        children: [
            {
                path: 'careerGuide/StreamSelectorTest',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <StreamSelectorTest />,
            },
            {
                path: 'careerGuide/PersonalityTest',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <PersonalityTest />,
            },
            {
                path: 'careerGuide/MultipleIntelligenceTest',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <MultipleIntelligenceTest />,
            },
            {
                path: 'careerGuide/Learningstyletest',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <Learningstyletest />,
            },
            {
                path: 'careerGuide/Idealcareertest',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <Idealcareertest />,
            },
            {
                path: 'careerGuide/Humanities',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <Humanities />,
            },
            {
                path: 'careerGuide/Engineering',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <Engineering />,
            },
            {
                path: 'careerGuide/Commerece',
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'student-signup' });
                },
                element: <Commerece />,
            },
            {
                path: 'KeytwosuccessTest/:userId/:testCode',
                element: <KeytwosuccessTest />,
            },
        ],
        errorElement: <ErrorPage />,
    },
    {
        path: '/management/:schoolDomain',
        children: [
            {
                path: 'login',
                loader: async ({ params }) => {
                    document.title = 'Manage Your Student and Alumni Community';
                    return pageLoader({ ...params, pageName: 'school-management-login' });
                },
                element: <ManagementLogin />,
            },
        ],
        errorElement: <ErrorPage />,
    },
    {
        path: '/internal/qna-dashboard',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    document.title = 'Student QNA';
                    return QnaApiService.pageLoader({ ...params, pageName: 'qna' });
                },
                element: <StudentDashboard />,
            },
        ],
    },
    {
        path: '/management/psychometric-bas-mapping',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    document.title = 'Psychometric Test and BAS Mapping';
                    return PsychometricTestMappingService.pageLoader({ ...params, pageName: 'psychometric_bas_mapping' });
                },
                element: <PsychometricTestMapping />,
            },
        ],
    },
    {
        path: '/schoolApiKey',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'api-key',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return SchoolApiService.pageLoader({ ...params, pageName: 'support-alumni-school' });
                },
                element: <SchoolApi key="support-alumni-school" />,
            },
        ],
    },
    {
        path: 'student/dashboard',
        loader: async ({ params }) => {
            return DashboardService.pageLoader({ ...params, pageName: 'alumni-dashboard' });
        },
        element: <Dashboard />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/student/:id/profile',
        errorElement: <ErrorPage />,
        element: (
            <>
                {/* <header>
                    <HeaderControl />
                    <MenuBuilder />
                </header> */}

                <StudentProfile key="ALUMNI_PROFILE" />
            </>
        ),
        loader: async ({ params }) => {
            return StudentService.pageLoader({ ...params, pageName: 'student-profile', includeAdditionalInfo: true });
        },
        children: [
            { path: '', element: <Preferences /> },
            { path: 'preference', element: <Preferences /> },
            { path: 'parent-info', element: <ParentInformation /> },
            { path: 'education', element: <EducationDetails /> },
            { path: 'entrance-exams', element: <EntranceExams /> },
            { path: 'extra-curricular', element: <ExtraCurricular /> },
        ],
    },
      {
        path: 'company',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'listing',
                loader: async ({ params }) => {
                    document.title = 'Manage Companies';
                    return CompanyListingService.pageLoader({ ...params, pageName: 'company-list' });
                },
                element: <CompanyListing key="company-list" />,
            },
            {
                path: 'add-new',
                loader: async ({ params }) => {
                    document.title = 'Add Company';
                    return CompanyService.pageLoader({ ...params, id: 'new' });
                },
                element: <Company />,
            },
            {
                path: ':id/basic-info',
                loader: async ({ params }) => {
                    document.title = 'Edit Company';
                    return CompanyService.pageLoader({ ...params });
                },
                element: <Company />,
            },
            {
                path: ':id/view',
                loader: async ({ params }) => {
                    document.title = 'View Company';
                    return CompanyService.pageLoader({ ...params });
                },
                element: <CompanyView />,
            },
        ],
    },
    {
        path: '/student/:id',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'info',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({ ...params, pageName: 'student-basic-info' });
                },
                element: <StudentBasicInfo />,
            },
            {
                path: 'education',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({ ...params, pageName: 'student-education' });
                },
                element: <Education />,
            },
            {
                path: 'entrance-exam',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({ ...params, pageName: 'student-entrance-exams' });
                },
                element: <EntranceExam />,
            },
            {
                path: 'achievements',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({ ...params, pageName: 'student-achievements', includeAdditionalInfo: true });
                },
                element: <StudentAchievement />,
            },
            {
                path: 'books',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({ ...params, pageName: 'student-reading-interest', includeAdditionalInfo: true });
                },
                element: <StudentBooks />,
            },
            {
                path: 'activity',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({ ...params, pageName: 'student-activity', includeAdditionalInfo: true });
                },
                element: <StudentActivity />,
            },
            {
                path: 'parent-info',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({ ...params, pageName: 'student-parents', includeAdditionalInfo: true });
                },
                element: <Parents />,
            },
            {
                path: 'student-preference',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({ ...params, pageName: 'student-education-preferences', includeAdditionalInfo: true });
                },
                element: <StudentPreference />,
            },
            {
                path: 'profile-picture',
                loader: async ({ params }) => {
                    return StudentService.pageLoader({
                        ...params,
                        pageName: 'alumni-profile-picture',
                        includeAdditionalInfo: true,
                    });
                },
                element: <AlumniProfileImage />,
            },
        ],
    },

    {
        path: '/alumni-invite',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'peer',
                element: <PeerInvite pageTitle="Send Invites" />,
            },
        ],
    },
    {
        path: '/socialmedia',
        element: <ManagementLayout />,
        children: [
            {
                path: 'social-integration/:tab?',
                element: <ManageSocialIntegrations />,
            },
            {
                path: 'socialpage',
                element: <SocialMedia />,
            },
            {
                path: 'socialpost/:id?',
                element: <SocialPost />,
            },
            {
                path: 'social-login-success',
                element: <SocialLoginSuccess />,
            },
            {
                path: 'instagram-login-success',
                element: <InstagramLoginSuccess />,
            },
            {
                path: 'linkedin-login-success',
                element: <LinkedinLoginSuccess />,
            },
            {
                path: 'posts/:tab?',
                loader: async ({ params }) => {
                    return SocialPostListService.pageLoader({ ...params, pageName: 'socialmedia-posts' });
                },
                element: <SocialPostList />,
            },
        ],
        errorElement: <ErrorPage />,
    },
    {
        path: '/share-profile',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <ShareMyProfile />,
            },
        ],
    },
    {
        path: '/user/ryan/login',
          loader: async ({ params }) => {
            document.title = 'Ryan Group - Ryan Connect';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
        element: <RyanLogin pageTitle="Ryan Group - Ryan Connect" />,
    },
    
     {
        path: '/user/euro/login',
          loader: async ({ params }) => {
            document.title = 'Euro - Euro Group Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <EuroLogin pageTitle="Euro - Euro Group Alumni Network" />,
    },
     {
        path: '/user/bhis/login',
          loader: async ({ params }) => {
            document.title = 'Billabong High - BHIS Alumni Networkk';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <BhisLogin pageTitle="Billabong High - BHIS Alumni Network" />,
    },
     {
        path: '/user/bomis/login',
          loader: async ({ params }) => {
            document.title = 'BOMIS - BOMIS Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <BomisLogin pageTitle="BOMIS - BOMIS Alumni Network" />,
    },
     {
        path: '/user/aster/login',
          loader: async ({ params }) => {
            document.title = 'Aster - Aster Group Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <AsterLogin pageTitle="Aster - Aster Group Alumni Network" />,
    },
     {
        path: '/user/vishwakarma/login',
          loader: async ({ params }) => {
            document.title = 'Vishwakarma Group - Vishwakarma Group Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <VishwakarmaLogin pageTitle="Vishwakarma Group - Vishwakarma Group Alumni Network" />,
    },
    {
        path: '/user/podar/login',
          loader: async ({ params }) => {
            document.title = 'Podar Group - Podar Group Alumni Network';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <PodarLogin pageTitle="Podar Group - Podar Group Alumni Network" />,
    },
    {
        path: '/user/vibgyor/login',
          loader: async ({ params }) => {
            document.title = 'Vibgyor Group of Schools';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <VgosLogin pageTitle="Vibgyor Group of Schools" />,
    },
    {
        path: '/user/adityaacademy/login',
          loader: async ({ params }) => {
            document.title = 'Aditya Academy Group';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <Adityaacademy pageTitle="Aditya Academy Group" />,
    },
    {
        path: '/user/adityabirla/login',
          loader: async ({ params }) => {
            document.title = 'Aditya Birla';
            return pageLoader({ ...params, pageName: 'alumni-login' });
        },
          element: <Adityabirla pageTitle="Aditya Birla" />,
    },
    {
        path: '/broadcast/ask-google-review',
        element: <GoogleReview pageTitle="Email TemplatAsk Google Review" />,
    },
    {
        path: '/broadcast/add-google-review',
        element: <AddGoogleReview pageTitle="Email TemplatAsk Google Review" />,
    },
    {
        path: '/broadcast/add-referral',
        element: <AddReferral pageTitle="Add your reference" />,
    },

    {
        path: '/image-template',

        element: <StandardLayout />,

        errorElement: <ErrorPage />,

        children: [
            {
                path: 'add-image',
                element: <AddImage pageTitle="add Image" />,
            },
            {
                path: 'future-leaders',
                element: <FutureLeaders pageTitle="Leaders of the Futures" />,
            },
            {
                path: 'future-leaders-three',
                element: <FutureLeadersThree pageTitle="Leaders of the Futures 3" />,
            },
            {
                path: 'future-leaders-four',
                element: <FutureLeadersFour pageTitle="Leaders of the Futures 4" />,
            },
            {
                path: 'webinar-certificate',
                element: <WebinarCertificate pageTitle="Webinar" />,
            },
            {
                path: '',
                element: <ImageTemplate pageTitle="Create Template" />,
            },
            {
                path: 'membership-card',
                element: <MembershipCard pageTitle="Create Template" />,
            },
            {
                path: 'rising-star',
                element: <RisingStar pageTitle="Create Template" />,
            },
            {
                path: 'success-story',
                element: <SuccessStory pageTitle="SuccessStory" />,
            },
            {
                path: 'add-spotlight-insta',
                element: <AddSpotlightsInsta pageTitle="AddSpotlightsInsta" />,
            },
            {
                path: 'future-leaders-insta',
                element: <FutureLeadersInst pageTitle="FutureLeadersInst" />,
            },
            {
                path: 'future-leaders-three-insta',
                element: <FutureLeadersThreeInsta pageTitle="FutureLeadersThreeInsta" />,
            },
            {
                path: 'future-leaders-four-insta',
                element: <FutureLeadersFourInsta pageTitle="FutureLeadersFourInsta" />,
            },
              {
                path: 'five-template',
                element: <FiveTemplate pageTitle="FiveTemplate" />,
            },  
            {
                path: 'future-leaders-six',
                element: <FutureLeadersSix pageTitle="FutureLeadersSeven" />,
            },
            {
                path: 'future-leaders-seven',
                element: <FutureLeadersSeven pageTitle="FutureLeadersEight" />,
            },
            {
                path: 'future-leaders-eight',
                element: <FutureLeadersEight pageTitle="FutureLeadersEight" />,
            },
            {
                path: 'future-leaders-nine',
                element: <FutureLeadersNine pageTitle="FutureLeadersSix" />,
            },
        ],
    },
    {
        path: '/reference',

        element: <StandardLayout />,

        errorElement: <ErrorPage />,

        children: [
            {
                path: 'manage/:name?',
                //used name for profile marker admission Referral link redirect here
                loader: async ({ params }) => {
                    document.title = 'Reference Management';

                    return ManageReferralService.pageLoader({ ...params, pageName: 'manage-referral' });
                },

                element: <ManageReferral key="manage-referral" />,
            },
            {
                path: 'update-track',
                element: <UpdateTrack pageTitle="Update Track" />,
            },
            {
                path: 'view-track',
                element: <ViewTrack pageTitle="View Track" />,
            },
        ],
    },
    {
        path: '/broadcast',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'createnew',
                element: <Sendemail pageTitle="Broadcast" />,
            },
            {
                path: 'addcontent',
                element: <AddContent pageTitle="Broadcast" />,
            },
            {
                path: 'templatepreview',
                element: <TemplatePreview pageTitle="Broadcast" />,
            },
            {
                path: 'template-preview-later',
                element: <TemplatePreviewLater pageTitle="Broadcast" />,
            },
            {
                path: 'student-profiles',
                loader: async ({ params }) => {
                    document.title = 'Student Management';
                    return ManageAlumniService.pageLoader({ ...params, pageName: 'track-student-profiles', deferList: true });
                },
                element: <ManageStudent key="track-student-profiles" />,
            },
            {
                path: 'email-templates',
                errorElement: <ErrorPage />,
                loader: async ({ params }) => {
                    return pageLoader({ ...params, pageName: 'alumni-signup' });
                },
                element: <TemplateList pageTitle="Email Template" />,
            },
            {
                path: 'alumni-profiles',
                loader: async ({ params }) => {
                    document.title = 'Alumni Management';
                     return ManageAlumniService.pageLoader({ ...params, pageName: 'track-alumni-profiles', deferList: true });
                },
                element: <ManageStudent key="track-alumni-profiles" />,
            },
            {
                path: 'emailpreview',
                element: <EmailPreview />,
            },
            {
                path: 'preview-later',
                element: <PreviewLater />,
            },
            {
                path: '',
                element: <DraftMail pageTitle="Broadcast" />,
            },
            {
                path: 'sent-mail',
                element: <SentMail pageTitle="Broadcast" />,
            },
            {
                path: 'schedule-mail',
                element: <ScheduleMail pageTitle="Broadcast" />,
            },
            {
                path: 'lead-profiles',
                loader: async ({ params }) => {
                    return ManageLeadService.pageLoader({ ...params, pageName: 'manage-lead' });
                },
                element: <ManageBroadcastLead key="manage-lead" />,
            },
            {
                path: 'import-html',
                element: <HtmlTemplate pageTitle="Broadcast" />,
            },
        ],
    },
    {
        path: '/update-alumni',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    return UpdateAlumniService.pageLoader({
                        ...params,
                        pageName: 'update-alumni',
                    });
                },
                element: <UpdateAlumni key="update-alumni" />,
            },
        ],
    },
    {
        path: 'reference/:schoolDomain?/users',
        loader: async ({ params }) => {
            document.title = 'Screening';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <Reference />,
    },
    {
        path: 'reference/:schoolDomain?/users-email-otp',
        loader: async ({ params }) => {
            document.title = 'Screening';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <ReferenceOtp />,
    },
    {
        path: 'reference/:schoolDomain?/verify-progress',
        loader: async ({ params }) => {
            document.title = 'verify-progress';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <VerifyProgress />,
    },
    {
        path: 'reference/:schoolDomain?/users-track',
        loader: async ({ params }) => {
            document.title = 'User Track';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <UserTrack />,
    },
    {
        path: 'alumni-entry',
        loader: async ({ params }) => {
            document.title = 'Alumni Entry';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <AlumniEntry />,
    },
    {
        path: 'screening/:schoolDomain?/signup',
        loader: async ({ params }) => {
            document.title = 'Screening';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <Screening />,
    },
    {
        path: 'screening/:schoolDomain?/info',
        loader: async ({ params }) => {
            document.title = 'Screening';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <ScreeningInfo />,
    },
    {
        path: 'screening/:schoolDomain?/identfyuser',
        loader: async ({ params }) => {
            document.title = 'Screening';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <IdenetyUser />,
    },
    {
        path: 'screening/:schoolDomain?/parent',
        loader: async ({ params }) => {
            document.title = 'Parent Form';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <Parent />,
    },
    {
        path: 'screening/:schoolDomain?/parent-child-info',
        loader: async ({ params }) => {
            document.title = 'Parent Form';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <ParentChildInfo />,
    },
    {
        path: 'screening/:schoolDomain?/past-student',
        loader: async ({ params }) => {
            document.title = 'Student Form';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <PastStudent />,
    },
    {
        path: 'screening/:schoolDomain?/thank-you',
        loader: async ({ params }) => {
            document.title = 'Thanks';
            return pageLoader({ ...params, pageName: 'alumni-signup' });
        },
        element: <ThanksPage />,
    },
    {
        path: '/moengage_report',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'upload-file',
                element: <UploadMoengage pageTitle="Moengage" />,
            },
        ],
    },
    {
        path: '/lead',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'browsefile',
                element: <BrowseFile />,
            },
            {
                path: 'add-personal-info',
                element: <AddLeadInfo />,
            },
            {
                path: 'add-target-program',
                element: <AddLeadProgram />,
            },
            {
                path: 'ManageLead',
                // loader: async ({ params }) => {
                //     return ProgramLisingService.pageLoader({
                //         ...params,
                //         pageName: 'program-list',
                //     });
                // },
                // element: <ProgramListing key="program-list" />,

                loader: async ({ params }) => {
                    document.title = 'Lead Management';
                    return ManageLeadService.pageLoader({ ...params, pageName: 'manage-lead' });
                },
                element: <ManageLead key="manage-lead" />,
            },
            {
                path: 'update-personal-info',
                element: <EditLeadInfo />,
            },
            {
                path: 'update-target-program',
                element: <TargetProgram />,
            },
            {
                path: 'lead-profile',
                element: <ViewProfile />,
            },
            {
                path: 'update-lead-program',
                element: <UpdateProgram />,
            },
        ],
    },
    {
        path: '/alumni-review',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'peer',
                loader: async ({ params }) => {
                    document.title = 'Review Peer Profiles';
                    return PeerReviewService.pageLoader({ ...params, pageName: 'alumni-review', searchBy: 'default' });
                },
                element: <PeerReview />,
            },
            {
                path: 'internal',
                loader: async ({ params }) => {
                    document.title = 'Review Profiles';
                    return PeerReviewService.pageLoader({ ...params, pageName: 'alumni-review', searchBy: 'default' });
                },
                element: <AdminPeerReview />,
            },
        ],
    },
    {
        path: '/email-verify',
        element: <AlumniProfileEditLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: ':id',
                element: <EmailVerification />,
            },
        ],
    },
    {
        path: '/event',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'manageevent',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return ManageEventService.pageLoader({ ...params, pageName: 'manage-event' });
                },
                element: <ManageEvent key="manage-event" />,
            },
            {
                path: 'add/:eventId?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return AddNewService.pageLoader({ ...params, pageName: 'add-event' });
                },
                element: <AddNew />,
            },
            {
                path: 'speaker-info/:eventId?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return SpeakerInfoService.pageLoader({ ...params, pageName: 'update-event-speaker' });
                },
                element: <SpeakerInfo />,
            },
            {
                path: 'audience-category/:eventId?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return AudienceCategoryService.pageLoader({ ...params, pageName: 'update-audience' });
                },
                element: <AudienceCategory />,
            },
            {
                path: 'theme-options/:eventId?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return ThemeOptionsService.pageLoader({ ...params, pageName: 'update-theme' });
                },
                element: <ThemeOptions />,
            },
            {
                path: 'preview/:eventId?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return PreviewService.pageLoader({ ...params, pageName: 'event-preview' });
                },
                element: <Preview />,
            },
             {
                path: 'attendance/:eventId?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return AddAttendanceService.pageLoader({ ...params, pageName: 'add-attendance' });
                },
                element: <AddAttendance />,
            },
        ],
    },
    {
        path: '/psychometriclink',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'psychometric-links',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return ManagePsyLinkService.pageLoader({ ...params, pageName: 'manage-psylink' });
                },
                element: <ManagePsyLink key="manage-psylink" />,
            },
            {
                path: 'add',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return AddPsyNewService.pageLoader({ ...params, pageName: 'add-psy' });
                },
                element: <AddPsyNew />,
            },
        ],
    },
    {
        path: '/management',
        element: <ManagementLayout />,
        //element: <ProtectedRoute isAuthenticated={App.isAuthenticated} component={ManagementLayout} />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'home',
                element: <Home />,
                //element: <ProtectedRoute isAuthenticated={App.isAuthenticated} component={Home} />,
            },
            // {
            //     path: 'student-listing',
            //     loader: async ({ params }) => {
            //         return StudentListService.pageLoader({ ...params, pageName: 'manage-students' });
            //     },
            //     element: <ManageStudents />,
            //     //element: <ProtectedRoute isAuthenticated={App.isAuthenticated} component={ManageStudents} />,
            // },
            {
                path: 'dashboard',
                loader: async ({ params }) => {
                    document.title = 'View Dashboard';
                    return ManagementDashboardService.pageLoader({ ...params, pageName: 'management-dashboard' });
                },
                element: <ManagementDashboard />,
                //element: <ProtectedRoute isAuthenticated={App.isAuthenticated} component={ManagementDashboard} />,
            },
            {
                path: 'grievance-v2',
                loader: async ({ params }) => {
                    document.title = 'Grievance Management';
                    return InstituteAdminGrievanceService.pageLoader({ ...params });
                },
                element: <InstituteAdminGrievanceScreen />,
            },
            {
                path: 'recruiter-dashboard',
                loader: async ({ params }) => {
                    document.title = 'View Recruiter Dashboard';
                    return RecruiterDashboardService.pageLoader({ ...params, pageName: 'recruiter-dashboard' });
                },
                element: <RecruiterDashboard />,
                //element: <ProtectedRoute isAuthenticated={App.isAuthenticated} component={ManagementDashboard} />,
            },
            {
                path: 'watchlist-dashboard/:instituteId',
                loader: async () => {
                    document.title = 'Watchlist Dashboard';
                    return null;
                },
                element: <WatchlistDashboard key="watchlist-dashboard" />,
            },
            {
                path: 'placement-analytics',
                loader: async () => {
                    document.title = 'Placement Analytics';
                    return null;
                },
                element: <PlacementInstituteShell roleBase="management" key="placement-analytics-mgmt" />,
            },
            {
                path: 'placement-analytics/:tab',
                loader: async () => {
                    document.title = 'Placement Analytics';
                    return null;
                },
                element: <PlacementInstituteShell roleBase="management" key="placement-analytics-mgmt-tab" />,
            },
            {
                path: 'profile-analytics-dashboard',
                loader: async () => {
                    document.title = 'Profile Analytics Dashboard';
                    return null;
                },
                element: <ProfileAnalyticsDashboardPage />,
            },
            // {
            //     path: 'manage-alumni',
            //     loader: async ({ params }) => {
            //         return ManageAlumniService.pageLoader({ ...params, pageName: 'manage-alumni' });
            //     },
            //     element: <ManageAlumni />,
            // },
        ],
    },
    {
        path: '/internal',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'testbyschool',
                loader: async ({ params }) => {
                    return PeerReviewService.pageLoader({ ...params, pageName: 'alumni-review', searchBy: 'default' });
                },
                element: <AdminPeerReview />,
            },
        ],
    },
    // {
    //     path: '/management/:id/profile',
    //     loader: async ({ params }) => {
    //         return StudentService.pageLoader({ ...params, pageName: 'admin-profile' });
    //     },
    //     element: <AdminProfile />,
    //     errorElement: <ErrorPage />,
    // },
    {
        path: '/management/:id',
        // loader: async ({ params }) => {
        //     return StudentService.pageLoader({ ...params, pageName: 'student-profile' });
        // },
        element: <ManagementLayout />,
        children: [
            {
                path: 'basic-info',
                loader: async ({ params }) => {
                    document.title = 'Update Basic Information';
                    return StudentService.pageLoader({ ...params, pageName: 'admin-basic-info' });
                },
                element: <AdminBasicInfo />,
            },
            {
                path: 'additional-info',
                loader: async ({ params }) => {
                    document.title = 'Management Profile';
                    return StudentService.pageLoader({ ...params, pageName: 'admin-additional-info' });
                },
                element: <AdminAdditionalInfo />,
            },
            {
                path: 'preferences',
                loader: async ({ params }) => {
                    document.title = 'Management Profile';
                    return StudentService.pageLoader({ ...params, pageName: 'admin-preferences' });
                },
                element: <AdminPreferences />,
            },
            {
                path: 'profile',
                loader: async ({ params }) => {
                    document.title = 'Management Profile';
                    return StudentService.pageLoader({ ...params, pageName: 'admin-profile' });
                },
                element: <AdminProfile />,
            },
        ],
    },
    {
        path: '/sync-profile-marker',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    document.title = 'Profile Marker Sync';
                    return ManageProfileMarkerSyncService.pageLoader({ ...params, pageName: 'sync-profile-marker' });
                },
                element: <ManageProfileMarkerList key="profile-markers" />,
            },
        ],
    },
    {
        path: '/management/track',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'student-profiles',
                loader: async ({ params }) => {
                    document.title = 'Student Management';
                    return ManageAlumniService.pageLoader({ ...params, pageName: 'track-student-profiles' });
                },
                element: <ManageAlumni key="track-student-profiles" />,
            },
            {
                path: 'student-career-preferences',
                loader: async ({ params }) => {
                    document.title = 'Student Management';
                    return ManageAlumniService.pageLoader({ ...params, pageName: 'track-student-career-preferences' });
                },
                element: <ManageAlumni key="track-student-career-preferences" />,
            },
            {
                path: 'alumni-profiles',
                loader: async ({ params }) => {
                    document.title = 'Alumni Management';
                    return ManageAlumniService.pageLoader({ ...params, pageName: 'track-alumni-profiles' });
                },
                element: <ManageAlumni key="track-alumni-profiles" />,
            },
            {
                path: 'activity-log-report',
                element: <ActivityLogReport key="track-activity-log-report" />,
            },
            {
                path: 'alumni-education-preferences',
                loader: async ({ params }) => {
                    document.title = 'Alumni Management';
                    return ManageAlumniService.pageLoader({ ...params, pageName: 'track-alumni-education-preferences' });
                },
                element: <ManageAlumni key="track-alumni-education-preferences" />,
            },
            {
                path: 'alumni-engagement-with-students',
                loader: async ({ params }) => {
                    document.title = 'Alumni Management';
                    return ManageAlumniService.pageLoader({ ...params, pageName: 'track-alumni-engagement-with-students' });
                },
                element: <ManageAlumni key="track-alumni-engagement-with-students" />,
            },
            {
                path: 'alumni-highlights-with-students-engagement',
                loader: async ({ params }) => {
                    return ManageAlumniServiceEngage.pageLoader({
                        ...params,
                        pageName: 'track-alumni-highlights-with-students-engagement',
                    });
                },
                element: <ManageAlumniEngage key="track-alumni-highlights-with-students-engagement" />,
                //element: <ManageAlumni key="track-alumni-engagement-with-students" />,
            },
        ],
    },

    {
        path: '/management/:pageName',
        element: <StudentManagementReport />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/notification',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <AlumniNotification pageTitle="Notifications for you" />,
            },
        ],
    },
    {
        path: '/email-verification/:id',
        element: <BlankLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <AlumniEmailVerification />,
            },
        ],
    },
    {
        path: '/notification',
        element: <StandardLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <AlumniNotification />,
            },
        ],
    },
    {
        path: '/email-verification/:id',
        element: <BlankLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <AlumniEmailVerification />,
            },
        ],
    },
    {
        path: '/sso/:hash/:redirect_url?',
        element: <BlankLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <AutoLogin />,
            },
        ],
    },
    {
        path: '/sso/:hash/:redirect_url/:redirect_user_id?',
        element: <BlankLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <AutoLogin />,
            },
        ],
    },
    {
        path: '/ssoi/:hash/:loginMode/:redirect_url?',
        element: <BlankLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <AutoLogin />,
            },
        ],
    },
    {
        path: '/support',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'alumni-school',
                loader: async ({ params }) => {
                    return AlumniSchoolSupportService.pageLoader({ ...params, pageName: 'support-alumni-school' });
                },
                element: <AlumniSchoolSupport key="support-alumni-school" />,
            },
            {
                path: 'alumni-school/:schoolId/:programLevel',
                loader: async ({ params }) => {
                    return AlumniSchoolSupportService.pageLoader({ ...params, pageName: 'support-alumni-school' });
                },
                element: <AlumniSchoolSupport key="support-alumni-school" />,
            },
            {
                path: 'alumni-school-group/:schoolGroupId/:programLevel',
                loader: async ({ params }) => {
                    return AlumniSchoolSupportService.pageLoader({ ...params, pageName: 'support-alumni-school' });
                },
                element: <AlumniSchoolSupport key="support-alumni-school" />,
            },
            {
                path: 'alumni-school/:schoolGroupId/:schoolId/:programLevel',
                loader: async ({ params }) => {
                    return AlumniSchoolSupportService.pageLoader({ ...params, pageName: 'support-alumni-school' });
                },
                element: <AlumniSchoolSupport key="support-alumni-school" />,
            },

            {
                path: 'alumni-student-match',
                loader: async ({ params }) => {
                    return AlumniMatchStudentsService.pageLoader({ ...params, pageName: 'alumni-student-match' });
                },
                element: <AlumniMatchStudents />,
            },

            {
                path: 'burner-analysis',
                loader: async ({ params }) => {
                    return BurnerAnalysisService.pageLoader({ ...params, pageName: 'burner-analysis-institutes' });
                },
                element: <BurnerAnalysisInstitutes />,
            },

            {
                path: 'burner-analysis/institute/:instituteId',
                loader: async ({ params }) => {
                    return BurnerAnalysisService.alumniPageLoader({ ...params, pageName: 'burner-analysis-alumni' });
                },
                element: <BurnerAnalysisAlumni />,
            },

            {
                path: 'placement-analytics',
                loader: async () => {
                    document.title = 'Placement Analytics';
                    return null;
                },
                element: <PlacementAnalyticsListing key="placement-analytics-listing" />,
            },
            {
                path: 'placement-analytics/:instituteId',
                loader: async () => {
                    document.title = 'Placement Analytics';
                    return null;
                },
                element: <PlacementInstituteShell roleBase="support" key="placement-analytics-support" />,
            },
            {
                path: 'placement-analytics/:instituteId/:tab',
                loader: async () => {
                    document.title = 'Placement Analytics';
                    return null;
                },
                element: <PlacementInstituteShell roleBase="support" key="placement-analytics-support-tab" />,
            },

            {
                path: 'create-new-user',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return CreateNewAlumniService.pageLoader({ ...params, pageName: 'create-new-user' });
                },
                element: <CreateNewAlumni />,
            },
            {
                path: 'all-school-summary',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-all-school-summary' });
                },
                element: <InternalAdminReport key="internal-admin-all-school-summary" />,
            },
            {
                path: 'watchlist-dashboard/:instituteId',
                loader: async () => {
                    document.title = 'Watchlist Dashboard';
                    return null;
                },
                element: <WatchlistDashboard key="watchlist-dashboard" />,
            },
            {
                path: 'watchlist-report',
                loader: async () => {
                    document.title = 'Watchlist Report';
                    return null;
                },
                element: <WatchlistReportPage key="watchlist-report" />,
            },
	    {
                path: 'custom-watchlist-report',
                loader: async () => {
                    document.title = 'Custom Watchlist Report';
                    return null;
                },
                element: <CustomWatchlistReportPage key="custom-watchlist-report" />,
            },
            {
                path: 'hitl-review-queue',
                loader: async () => {
                    document.title = 'HITL Review Queue';
                    return null;
                },
                element: <HitlReviewQueuePage key="hitl-review-queue" />,
            },
            {
                path: 'hitl-config',
                loader: async () => {
                    document.title = 'HITL Configuration';
                    return null;
                },
                element: <HitlConfigPage key="hitl-config" />,
            },
            {
                path: 'program-report',
                loader: async ({ params }) => {
                    document.title = 'Program Report';
                    return ProgramLisingService.pageLoader({ ...params, pageName: 'program-report' });
                },
                element: <ProgramListing key="program-report" />,
            },
            {
                path: 'add-program',
                loader: async ({ params }) => {
                    document.title = 'Add Program';
                    return InstituteProgramService.pageLoader({
                        ...params,
                        pageName: 'add-program-super-admin',
                    });
                },
                element: <CreateinstituteProgram key="add-program-super-admin" />,
            },
            {
                path: 'edit-program/:id',
                loader: async ({ params }) => {
                    document.title = 'Edit Program';
                    return InstituteProgramService.pageLoader({
                        ...params,
                        pageName: 'add-program-super-admin',
                    });
                },
                element: <CreateinstituteProgram key="edit-program-super-admin" />,
            },
             {
                path: 'story-repository',
                loader: async () => {
                    if (!isSuperAdmin()) throw new Response('Unauthorized access', { status: 403, statusText: 'Unauthorized access' });
                    document.title = 'Story Repository';
                    return null;
                },
                element: <StoryRepository />,
            },
             {
                path: 'story/new',
                loader: async () => {
                    if (!isSuperAdmin()) throw new Response('Unauthorized access', { status: 403, statusText: 'Unauthorized access' });
                    document.title = 'Add Story';
                    return null;
                },
                element: <StoryForm />,
            },
            {
                path: 'story/:storyId/edit',
                loader: async () => {
                    if (!isSuperAdmin()) throw new Response('Unauthorized access', { status: 403, statusText: 'Unauthorized access' });
                    document.title = 'Edit Story';
                    return null;
                },
                element: <StoryForm />,
            },
            {
                path: 'story/:storyId',
                loader: async () => {
                    if (!isSuperAdmin()) throw new Response('Unauthorized access', { status: 403, statusText: 'Unauthorized access' });
                    document.title = 'Story';
                    return null;
                },
                element: <StoryView />,
            },
            {
                path: 'all-school-statistics',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-all-school-statistics' });
                },
                element: <InternalAdminReport key="internal-admin-all-school-statistics" />,
            },
            {
                path: 'all-alumni-report/:schoolId?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-all-alumni-report' });
                },
                element: <InternalAdminReport key="internal-admin-all-alumni-report" />,
                children: [
                    {
                        path: ':profileCompletionStatusCode',
                        loader: async ({ params }) => {
                            return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-all-alumni-report' });
                        },
                        element: <InternalAdminReport key="internal-admin-all-alumni-report-profile-due" />,
                    },
                ],
            },
            {
                path: 'all-bas-report/:counsellorId?/:sessionBookedStatus?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return BasAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-all-bas-report' });
                },
                element: <BasAdminReport key="internal-admin-all-bas-report" />,
                children: [
                    {
                        path: ':profileCompletionStatusCode',
                        loader: async ({ params }) => {
                            return BasAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-all-alumni-report' });
                        },
                        element: <BasAdminReport key="internal-admin-all-alumni-report-profile-due" />,
                    },
                ],
            },
           {
                path: 'business-directory',
                loader: async ({ params }) => {
                    document.title = 'Business Directory';
                    return BusinessDirectoryService.pageLoader({ ...params, pageName: 'business-directory' });
                },
                element: <BusinessDirectory key="business-directory" />,
            },
            {
                path: 'business-directory/ai-suggested',
                loader: async ({ params }) => {
                    document.title = 'AI Suggested Providers';
                    return AiSuggestedService.pageLoader({ ...params, pageName: 'ai-suggested-directory' });
                },
                element: <AiSuggestedDirectory key="ai-suggested-directory" />,
            },
            {
                path: 'school-statistics/:instituteId?',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return SchoolStatisticsService.pageLoader({ ...params, pageName: 'internal-admin-school-statistics-report' });
                },
                element: <SchoolAdminStatisticsReport key="internal-admin-school-statistics-report" />,
            },
            {
                path: 'non-standard-colleges-report',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-user-entered-college' });
                },
                element: <InternalAdminReport key="internal-admin-user-entered-college" />,
            },
            {
                path: 'non-standard-exams-report',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-user-entered-exam' });
                },
                element: <InternalAdminReport key="internal-admin-user-entered-exam" />,
            },
            {
                path: 'qr-code-checkins-without-profiles',
                loader: async ({ params }) => {
                    document.title = 'QR Code Check-ins without Profiles';
                    return InternalAdminQRReportService.pageLoader({ ...params, pageName: 'internal-admin-qr-code-checkins-without-profiles' });
                },
                element: <InternalAdminQRReport key="internal-admin-qr-code-checkins-without-profiles" />,
            },
            {
                path: 'benefits-report',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-benefits-report' });
                },
                element: <InternalAdminReport key="internal-admin-benefits-report" />,
            },
            {
                path: 'registration_profile_maintenance_report',
                loader: async ({ params }) => {
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-benefits-report' });
                },
                element: <InternalAdminReport key="internal-admin-benefits-report" />,
            },
            {
                path: 'student-profile-report',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return ManageAlumniService.pageLoader({ ...params, pageName: 'internal-admin-all-student-report' });
                },
                element: <InternalAdminStudentReport key="internal-admin-all-student-report" />,
            },
            {
                path: 'profile-marker-report',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'internal-admin-profile-marker' });
                },
                element: <InternalAdminReport key="internal-admin-profile-marker" />,
            },
            {
                path: 'grievance',
                loader: async ({ params }) => {
                    document.title = 'Grievance Management';
                    return InternalAdminReportService.pageLoader({ ...params, pageName: 'inst-admin-grievance' });
                },
                element: <InternalAdminReport key="inst-admin-grievance" />,
            },
            {
                path: 'add-grievance',
                loader: async ({ params }) => {
                    document.title = 'Add New Grievance';
                    return GrievanceService.pageLoader({ ...params, pageName: 'add-grievance' });
                },
                element: <Grievance key="add-grievance" />,
            },
            {
                path: 'grievance-v2',
                loader: async ({ params }) => {
                    document.title = 'Grievance Management';
                    return InternalAdminGrievanceService.pageLoader({ ...params });
                },
                element: <InternalAdminGrievanceReport />,
            },            
            {
                path: 'outreach-dashboard',
                loader: async ({ params }) => {
                    document.title = 'Outreach Dashboard';
                    return OutreachDashboardService.pageLoader({ ...params, pageName: 'outreach-dashboard' });
                },
                element: <OutreachDashboard />,
            },
        ],
    },
    {
        path: 'institute',
        element: <ManagementLayout />,
        children: [
            {
                path: ':id',
                children: [
                    {
                        path: 'basic-info',
                        loader: async ({ params }) => {
                            document.title = 'Univariety';
                            return InstituteService.pageLoader({ ...params, pageName: 'admin-institute-create' });
                        },
                        element: <Institute />,
                    },
                    {
                        path: 'online-preference',
                        loader: async ({ params }) => {
                            document.title = 'Univariety';
                            return InstituteService.pageLoader({ ...params, pageName: 'institute-online-preference' });
                        },
                        element: <Institute />,
                    },
                    {
                        path: ':groupId/contacts',
                        loader: async ({ params }) => {
                            document.title = 'Univariety';
                            return ContactService.pageLoader({ ...params, pageName: 'admin-institute-contacts' });
                        },
                        element: <Contact />,
                    },
                    {
                        path: 'institute-onboarding',
                        loader: async ({ params }) => {
                            document.title = 'Univariety';
                            return InstituteService.pageLoader({ ...params, pageName: 'admin-institute-onboarding' });
                        },
                        element: <Institute />,
                    },
                    {
                        path: 'commitment-paths',
                        loader: async ({ params }) => {
                            document.title = 'Commitment Paths';
                            return InstituteService.pageLoader({ ...params, pageName: 'admin-institute-commitment-paths' });
                        },
                        element: <Institute />,
                    },
                    {
                        path: 'handle-batch',
                        loader: async ({ params }) => {
                            document.title = 'Handle Batch';
                            return InstituteService.pageLoader({ ...params, pageName: 'admin-institute-handle-batch' });
                        },
                        element: <Institute />,
                    },
                    {
                        path: 'profile-analytics',
                        loader: async ({ params }) => {
                            document.title = 'Profile Analytics';
                            return InstituteService.pageLoader({ ...params, pageName: 'admin-institute-profile-analytics' });
                        },
                        element: <Institute />,
                    },
                ],
            },
            {
                path: 'listing',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return InstituteLisingService.pageLoader({
                        ...params,
                        pageName: 'institute-list',
                    });
                },
                element: <InstituteListing key="institute-list" />,
            },
            {
                path: ':id/:groupId/contact-listing',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return ContactLisingService.pageLoader({
                        ...params,
                        pageName: 'contact-list',
                    });
                },
                element: <ContactListing key="contact-list" />,
            },
            {
                path: ':uuid/:id/:groupId/contact-edit',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return ContactService.pageLoader({ ...params, pageName: 'admin-institute-contacts' });
                },
                element: <Contact />,
            },
            {
                path: ':id/:groupId/:pageAction/contact-add',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return ContactService.pageLoader({ ...params, pageName: 'admin-institute-contacts' });
                },
                element: <Contact />,
            },
        ],
    },
    {
        path: '/internal/track',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'alumni-highlights-with-students-engagement',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return AlumniEngagementService.pageLoader({
                        ...params,
                        pageName: 'track-alumni-highlights-with-students-engagement',
                    });
                },
                element: <AlumniEngagement key="track-alumni-highlights-with-students-engagement" />,
            },
            {
                path: 'conversation-report',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return ConversationReportService.pageLoader({
                        ...params,
                        pageName: 'conversation-report',
                    });
                },
                element: <ConversionsReport key="conversation-report" />,
            },
        ],
    },
    {
        path: '/internal',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'alumni-interaction/:id/:instituteId',
                loader: async ({ params }) => {
                    document.title = 'Univariety';
                    return AlumniConversionsService.pageLoader({
                        ...params,
                        pageName: 'alumni-interaction',
                    });
                },
                element: <AlumniConversions key="alumni-interaction" />,
            },
        ],
    },
    {
        path: '/',
        children: [
            {
                path: 'valuable-conversation/:id',
                element: <AlumniSelectedConversions key="alumni-selected-interaction" />,
            },
            {
                path: 'submit-feedback/:id/:userId/:loadType?',
                element: <RenderFeedbackForm key="submit-feedback" />,
            },
            {
                path: 'paceform/parentselfbooking/:userId',
                element: <PaceFormParentSelfBooking key="paceform-parentselfbooking" />,
            },
        ],
    },
   

    {
        path: '/internal/track',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'alumni-highlights-with-students-engagement',
                loader: async ({ params }) => {
                    return AlumniEngagementService.pageLoader({
                        ...params,
                        pageName: 'track-alumni-highlights-with-students-engagement',
                    });
                },
                element: <AlumniEngagement key="track-alumni-highlights-with-students-engagement" />,
            },
        ],
    },
    {
        path: '/internal',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'alumni-interaction/:id',
                loader: async ({ params }) => {
                    return AlumniConversionsService.pageLoader({
                        ...params,
                        pageName: 'alumni-interaction',
                    });
                },
                element: <AlumniConversions key="alumni-interaction" />,
            },
        ],
    },
    {
        path: '/',
        children: [
            {
                path: 'valuable-conversation/:id',
                element: <AlumniSelectedConversions key="alumni-selected-interaction" />,
            },
        ],
    },

     {
        path: 'commitment',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                // adminCallLogId optional: present → opened from an existing
                // outreach-log row (Call Session block hidden, saves attach to it);
                // absent → call-first flow (dropdowns + click-to-call button).
                path: 'capture/:instituteId/:userId/:adminCallLogId?',
                loader: async ({ params }) => {
                    document.title = 'Commitment Capture';

                    return CommitmentService.pageLoader({
                        ...params,
                    });
                },
                element: <CommitmentCapture />,
            },
            {
                path: 'tracker/:instituteId',
                loader: async ({ params }) => {
                    document.title = 'Commitment Tracker';

                    return CommitmentService.trackerLoader({
                        ...params,
                    });
                },
                element: <CommitmentTracker />,
            },
        ],
    },
    {
        path: '/program',
        element: <ManagementLayout />,
        children: [
            {
                path: 'add-program',
                loader: async ({ params }) => {
                    document.title = 'Add Program';
                    return InstituteProgramService.pageLoader({
                        ...params,
                        pageName: 'add-program',
                    });
                },
                element: <CreateinstituteProgram />,
            },
            {
                path: 'edit-program/:id',
                loader: async ({ params }) => {
                    document.title = 'Edit Program';
                    return InstituteProgramService.pageLoader({
                        ...params,
                        pageName: 'add-program',
                    });
                },
                element: <CreateinstituteProgram />,
            },
            {
                path: 'add-outcome-info',
                loader: async ({ params }) => {
                    return InstituteProgramService.pageLoader({
                        ...params,
                        pageName: 'add-outcome-info',
                    });
                },
                element: <CreateinstituteProgram />,
            },
            {
                path: 'listing',
                loader: async ({ params }) => {
                    document.title = 'Programs';
                    return ProgramLisingService.pageLoader({
                        ...params,
                        pageName: 'program-list',
                    });
                },
                element: <ProgramListing key="program-list" />,
            },
        ],
    },
    {
        path: '/widget',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'listing',
                loader: async ({ params }) => {
                    document.title = 'Widgets';
                    return ManageWidgetsListService.pageLoader({
                        ...params,
                        pageName: 'widget-list',
                    });
                },
                element: <ManageWidgetsList key="widget-list" />,
            },
            {
                path: 'configure/:code/:id?',
                loader: async ({ params }) => {
                    document.title = 'Manage Widget';
                    return WidgetService.pageLoader({
                        ...params,
                        pageName: 'widget-configuration',
                    });
                },
                element: <WidgetConfiguration />,
            },
            {
                path: 'configuration/:code/:id?',
                loader: async ({ params }) => {
                    document.title = 'Manage Widget';
                    return WidgetService.pageLoader({
                        ...params,
                        pageName: 'widget-configuration',
                    });
                },
                element: <Configuration />,
            },
            {
                path: ':code/preview',
                loader: async ({ params }) => {
                    document.title = 'Widget Preview';
                    return WidgetService.pageLoader({
                        ...params,
                        pageName: 'widget-preview',
                    });
                },
                element: <WidgetConfiguration />,
            },
            {
                path: 'configurelist/:code/:id?',
                loader: async ({ params }) => {
                    document.title = 'Manage Alumni List Widget';
                    return WidgetServiceList.pageLoader({
                        ...params,
                        pageName: 'widget-listing-configuration',
                    });
                },
                element: <WidgetConfigurationList />,
            },
            {
                path: 'addguidingalumni/:code/:id?',
                loader: async ({ params }) => {
                    document.title = 'Manage Alumni List Widget';
                    return AddGuidingAlumniList.pageLoader({
                        ...params,
                        pageName: 'widget-listing-configuration',
                    });
                },
                element: <AddGuidingAlumni />,
            },
            {
                path: 'editguidingalumni/:code/:id/:eid?',
                loader: async ({ params }) => {
                    document.title = 'Manage Alumni List Widget';
                    return AddGuidingAlumniList.pageLoader({
                        ...params,
                        pageName: 'widget-listing-configuration',
                    });
                },
                element: <AddGuidingAlumni />,
            },
        ],
    },

    {
        path: '/support',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'sync-profile-level',
                loader: async ({ params }) => {
                    return ProfieLevelSyncService.pageLoader({
                        ...params,
                        pageName: 'internal-admin-institute-profile-level-sync',
                    });
                },
                element: <ProfileLevelDetail key="internal-admin-institute-profile-level-sync" />,
            },
        ],
    },
    {
        path: '/domaincategory',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'list',
                loader: async ({ params }) => {
                    return DomainCategoryDataService.pageLoader({
                        ...params,
                        pageName: 'domain-data',
                    });
                },
                element: <DomainDetail key="domain-data" />,
            },
        ],
    },
    // {
    //     path: '/widget',
    //     element: <StandardLayout />,
    //     errorElement: <ErrorPage />,
    //     children: [
    //         {
    //             path: 'guiding-alumni',
    //             element: <AddGuidingAlumni />,
    //         },
    //         {
    //             path: 'guiding-alumni-preview',
    //             element: <GuidingAlumniPreview />,
    //         },
    //     ],
    // },
    {
        path: '/widgetview',
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'guiding-alumni-preview-frontend',
                element: <GuidingAlumniPreviewFrontend />,
            },
        ],
    },
    {
        path: '/profilemarkersnotes',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: ':id/list',
                loader: async ({ params }) => {
                    return ProfileMarkerNotesService.pageLoader({
                        ...params,
                        pageName: 'profilemarker-notes',
                    });
                },
                element: <ProfileMarkerNotes key="profilemarker-notes" />,
            },
        ],
    },
    {
        element: <StandardLayout />,
        path: 'top-colleges/',
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    document.title = 'Top Colleges';
                    return CollegeService.pageLoader({
                        ...params,
                    });
                },
                element: <TopColleges />,
            },
        ],
    },
    {
        element: <StandardLayout />,
        path: 'careers/',
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    document.title = 'Top Colleges';
                    return CollegeService.pageLoader({
                        ...params,
                    });
                },
                element: <TopCareer />,
            },
            {
                path: ':id',
                // loader: async ({ params }) => {
                //     document.title = 'Top Colleges';
                //     return CollegeService.pageLoader({
                //         ...params,
                //     });
                // },
                element: <CareerDetails />,
            },
        ],
    },
    {
        path: '/upload-user',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    return UploadUserService.pageLoader({
                        ...params,
                        pageName: 'upload-user',
                    });
                },
                element: <UploadUser key="upload-user" />,
            },
        ],
    },
    {
        path: '/upload-outreach',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    return UploadOutreachService.pageLoader({
                        ...params,
                        pageName: 'upload-outreach',
                    });
                },
                element: <UploadOutreach key="upload-outreach" />,
            },
        ],
    },
    {
        path: '/upload-tracker-data/:institute_id',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    return UploadTrackerService.pageLoader({
                        ...params,
                        pageName: 'upload-tracker-data',
                    });
                },
                element: <UploadTrackerData key="upload-tracker-data" />,
            },
        ],
    },
    {
        path: '/upload-profile-marker',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    return UploadProfileMarkerService.pageLoader({
                        ...params,
                        pageName: 'upload-profile-marker',
                    });
                },
                element: <UploadProfileMarker key="upload-profile-marker" />,
            },
        ],
    },
     {
        path: '/upload-recruiter',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    return UploadRecruiterService.pageLoader({
                        ...params,
                        pageName: 'upload-recruiter',
                    });
                },
                element: <UploadRecruiter key="upload-recruiter" />,
            },
        ],
    },
    {
        path: '/user-activity-dashboard',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <AlumniActivityDashboard />,
            },
        ],
    },
        {
        path: '/vibrancy-dashboard',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <VibrancyDashboard version="sm" />,
            },
        ],
    },
    {
        path: '/vibrancy-dashboard-client',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <VibrancyDashboard version="client" />,
            },
        ],
    },
    {
        path: '/upload-parent',
        element: <ManagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async ({ params }) => {
                    return UploadParentService.pageLoader({
                        ...params,
                        pageName: 'upload-user',
                    });
                },
                element: <UploadParent key="upload-parent" />,
            },
        ],
    },
  {
        // Bootstrap/school-dashboard design — renders inside the standard
        // app shell (header, nav, footer) provided by EngagementLayout.
        path: '/institute-automation-report-dashboard',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async () => {
                    document.title = 'Automated Report Module';
                    return null;
                },
                element: <InstituteAdminReports />,
            },
        ],
    },
    {
        // Standalone Preview & Send page (deep-linkable via ?institute_id=).
        path: '/institute-automation-report-preview',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async () => {
                    document.title = 'Preview & Send — Automated Report Module';
                    return null;
                },
                element: <PreviewSendPage />,
            },
        ],
    },
    {
        // Institute-facing read-only report view (scoped to the logged-in institute).
        path: '/institute-report',
        element: <EngagementLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                loader: async () => {
                    document.title = 'My Report';
                    return null;
                },
                element: <InstituteReportView />,
            },
        ],
    },
    
];

export default routes;
